<template>
  <div class="recommendations-page">
    <div class="page-header">
      <h1>Zalecenia</h1>
      <button class="btn-primary" @click="$router.push('/dla-biznesu/profile/recommendations/add')">
        + Stwórz nowe
      </button>
    </div>

    <div v-if="currentUser" class="layout">
      <section class="section-card list-card">
        <div class="section-card-header">
          <h2>Lista pacjentów</h2>
        </div>

        <div class="search-row">
          <input type="text" v-model="searchInput" id="searchInput" placeholder="Szukaj po imieniu/nazwisku lub zwierzaku...">
          <button class="btn-green" @click="searchPet">Szukaj</button>
          <button class="btn-outline" @click="resetSearch">Resetuj</button>
        </div>

        <div class="pets-list" v-if="pets.length > 0">
          <div v-for="pet in pets" :key="JSON.parse(pet).pet_id" class="pet-item">
            <div class="pet-item__info">
              <b>{{ JSON.parse(pet).name.split(',')[0] }}</b>
              <span>{{ JSON.parse(pet).name.split(',')[1] }}</span>
            </div>
            <button class="btn-icon" @click="setCurrentPet(JSON.parse(pet).pet_id)">
              <img src="@/assets/message-arrow.png" alt="szczegóły zalecenia">
            </button>
          </div>
        </div>

        <div v-else class="empty-state">
          <p>Brak zaleceń.</p>
        </div>
      </section>

      <section class="section-card details-card" v-if="currentPet">
        <div class="pet-header">
          <div class="pet-header__left">
            <img :src="currentPet.photo_url" :alt="currentPet.pet_name">
            <h3>{{ currentPet.pet_name }}</h3>
          </div>
          <button class="btn-icon close-btn" @click="currentPet = null">
            <img src="@/assets/icons/x.svg" alt="zamknij">
          </button>
        </div>

        <div class="recomms-list">
          <article class="recomm-item" v-for="recomm in currentPet.recommendations" :key="recomm.id">
            <div class="recomm-item__content">
              <span>
                {{ recomm.content.slice(recomm.content.indexOf('|') + 1).length > 90 ? `${recomm.content.slice(recomm.content.indexOf('|') + 1).slice(0, 90)}...` : recomm.content.slice(recomm.content.indexOf('|') + 1) }}
              </span>
              <p v-if="recomm.isExpanded && recomm.content.slice(recomm.content.indexOf('|') + 1).length > 90">
                {{ recomm.content.slice(recomm.content.indexOf('|') + 1).replace(/\n/g, '<br>') }}
              </p>
              <a :href="recomm.photo_url" target="_blank" v-if="recomm.isExpanded && recomm.photo_url">zdjęcie 1</a>
              <a :href="recomm.second_photo_url" target="_blank" v-if="recomm.isExpanded && recomm.second_photo_url">zdjęcie 2</a>
            </div>
            <button class="btn-icon recomm-item__expand" @click="() => recomm.isExpanded = !recomm.isExpanded">
              <img src="@/assets/message-arrow.png" :style="{ transform: `rotate(${recomm.isExpanded ? '90deg' : '-90deg'})` }" alt="rozwiń">
            </button>
          </article>
        </div>
      </section>

      <section class="section-card details-card" v-else>
        <div class="empty-state">
          <p>Wybierz zalecenie z listy.</p>
        </div>
      </section>
    </div>

    <div v-else class="section-card">
      <div class="empty-state">
        <p>Brak zaleceń.</p>
      </div>
    </div>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizProfileRecommendations',
  setup() {
    useMeta({ title: 'Zalecenia' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      searchInput: '',
      recommendations: [],
      pets: [],
      recommsCount: null,
      currentPet: null
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }

    if (this.appStore.isSubscribed) {
      this.getRecommendations();
    } else {
      this.$router.push('/dla-biznesu/profile/user-data');
    }
  },
  methods: {
    resetSearch() {
      this.searchInput = '';
      this.getRecommendations();
    },
    getRecommendations() {
      this.pets = [];
      axios.post(`/RecommendationSearch`, {
        page: 1,
        limit: 1,
        user_id: this.currentUser.id
      }, authHeader()).then((res) => {
        this.recommsCount = res.data.count;
        axios.post(`/RecommendationSearch`, {
          page: Math.floor(res.data.count / 50),
          limit: 50,
          user_id: this.currentUser.id
        }, authHeader()).then((resp) => {
          resp.data.items.forEach(item => {
            this.pets.push(JSON.stringify({ name: item.content.split('|')[0], pet_id: item.pet_id }));
          });
        }).then(() => {
          const petsTemp = [...new Set(this.pets)];
          this.pets = petsTemp;
        }).catch(() => {});
      }).catch(() => {});
    },
    setCurrentPet(id) {
      axios.get(`/Pet/${id}`).then(res => {
        this.currentPet = res.data[0];
        this.currentPet.recommendations.map(x => {
          x.isExpanded = false;
        });
      }).catch(() => {});
    },
    searchPet() {
      this.pets = [];
      axios.post(`/RecommendationSearch`, {
        page: 1,
        limit: this.recommsCount,
        user_id: this.currentUser.id
      }, authHeader()).then(res => {
        res.data.items.forEach(item => {
          this.pets.push(JSON.stringify({ name: item.content.split('|')[0], pet_id: item.pet_id }));
        });
      }).then(() => {
        const petsTemp = [...new Set(this.pets)];
        this.pets = petsTemp;
      }).then(() => {
        this.pets = this.pets.filter(item => JSON.parse(item).name.toLowerCase().includes(this.searchInput.toLowerCase()));
      }).catch(() => {});
    }
  }
};
</script>

<style scoped lang='scss'>
.recommendations-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}
.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
}

.layout {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 20px;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 20px;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0 0 12px 0;
  font-size: 2rem;
  color: #1f2937;
}

.search-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.search-row input {
  flex: 1 1 200px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  outline: none;
}
.search-row input:focus {
  border-color: #10b981;
}

.pets-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 480px;
  overflow-y: auto;
  padding-right: 4px;
}
.pet-item {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #e5e7eb;
  border-left: 3px solid #f97316;
  border-radius: 8px;
  padding: 10px;
}
.pet-item__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pet-item__info b {
  font-size: 1.4rem;
  color: #1f2937;
}
.pet-item__info span {
  font-size: 1.3rem;
  color: #6b7280;
}

.details-card {
  min-height: 560px;
}
.pet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 10px;
  margin-bottom: 12px;
}
.pet-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.pet-header__left img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 50%;
}
.pet-header__left h3 {
  margin: 0;
  font-size: 2rem;
}

.recomms-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.recomm-item {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.recomm-item__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.recomm-item__content span,
.recomm-item__content p {
  font-size: 1.4rem;
  color: #374151;
  margin: 0;
}
.recomm-item__content a {
  color: #2563eb;
  text-decoration: none;
  font-size: 1.3rem;
}
.recomm-item__content a:hover {
  text-decoration: underline;
}

.btn-primary,
.btn-green,
.btn-outline {
  border-radius: 8px;
  border: none;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}
.btn-primary {
  background: #f97316;
  color: #fff;
}
.btn-primary:hover { background: #ea6c0a; }

.btn-green {
  background: #10b981;
  color: #fff;
}
.btn-green:hover { background: #059669; }

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-icon img { width: 16px; height: 16px; }
.close-btn {
  border: none;
}
.close-btn img { width: 22px; height: 22px; }

.empty-state {
  text-align: center;
  padding: 26px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

@media (max-width: 900px) {
  .layout {
    grid-template-columns: 1fr;
  }
  .details-card {
    min-height: auto;
  }
}

@media (max-width: 480px) {
  .recommendations-page {
    padding: 16px 12px;
  }
  .page-header h1 {
    font-size: 2.2rem;
  }
  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }
  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>